
import React, { useState } from 'react';
import { Button, Modal, Table, Box, Text, Group } from '@mantine/core';
import { IconTable } from '@tabler/icons-react';

interface LegendButtonProps {
  data: Record<string, number>;
  colors: string[];
  modalTitle?: string;
}

const LegendButton: React.FC<LegendButtonProps> = ({
  data,
  colors,
  modalTitle = 'Allocation Details'
}) => {
  const [opened, setOpened] = useState(false);

  // Calculate total and prepare data for display
  const total = Object.values(data).reduce((sum, value) => sum + value, 0);
  
  const tableData = Object.entries(data).map(([key, value], index) => ({
    name: key,
    value: value,
    percentage: total > 0 ? ((value / total) * 100).toFixed(2) : '0.00',
    color: colors[index % colors.length] || '#000000'
  }));

  tableData.sort((a, b) => b.value - a.value);

  const rows = tableData.map((item, index) => (
    <Table.Tr key={item.name}>
      <Table.Td>
        <Group gap="xs" align="center">
          <Box
            w={16}
            h={16}
            style={{ 
              backgroundColor: item.color,
              borderRadius: '2px',
              flexShrink: 0
            }}
          />
          <Text size="sm">{item.name}</Text>
        </Group>
      </Table.Td>
      <Table.Td>
        <Text size="sm" ta="right">
          {item.value.toLocaleString()}
        </Text>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <Button
        leftSection={<IconTable size={16} />}
        onClick={() => setOpened(true)}
        fullWidth={true}
        variant="light"
      >
        Details
      </Button>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={modalTitle}
        size="md"
        centered
      >
        <Box>
          <Table striped>
            <Table.Thead>
              <Table.Tr>
                <Table.Th></Table.Th>
                <Table.Th ta="right">Value</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows}
            </Table.Tbody>
          </Table>
        </Box>
      </Modal>
    </>
  );
};

export default LegendButton;